import React from 'react';

const ImageRow = (props) => {
  return (
    <div className={`image-row image-row--items-${props.children.length}`}>
      {props.children}
    </div>
  );
};

export default ImageRow;
